import { render } from "./data_points.html?vue&type=template&id=548b481b&external"
import script from "./data_points.js?vue&type=script&lang=js&external"
export * from "./data_points.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__